/**
 * 印地语
 */
export default {
  name: 'hi',
  el: {
    colorpicker: { confirm: 'पुष्टि करें', clear: 'साफ करें' },
    datepicker: {
      now: 'अभी',
      today: 'आज',
      cancel: 'रद्द करें',
      clear: 'साफ करें',
      confirm: 'पुष्टि करें',
      selectDate: 'तारीख़ चुनें',
      selectTime: 'समय चुनें',
      startDate: 'आरंभ तिथि',
      startTime: 'आरंभ समय',
      endDate: 'समाप्ति तिथि',
      endTime: 'समाप्ति समय',
      prevYear: 'पिछला वर्ष',
      nextYear: 'अगला वर्ष',
      prevMonth: 'पिछला महीना',
      nextMonth: 'अगला महीना',
      year: 'वर्ष',
      month1: '1 महीना',
      month2: '2 महीना',
      month3: '3 महीना',
      month4: '4 महीना',
      month5: '5 महीना',
      month6: '6 महीना',
      month7: '7 महीना',
      month8: '8 महीना',
      month9: '9 महीना',
      month10: '10 महीना',
      month11: '11 महीना',
      month12: '12 महीना',
      weeks: {
        sun: 'रवि',
        mon: 'सोम',
        tue: 'मंगलवार',
        wed: 'बुध',
        thu: 'गुरु',
        fri: 'शुक्र',
        sat: 'शनि'
      },
      months: {
        jan: 'जनवरी',
        feb: 'फरवरी',
        mar: 'मार्च',
        apr: 'अप्रैल',
        may: 'मई',
        jun: 'जून',
        jul: 'जुलाई',
        aug: 'अगस्त',
        sep: 'सितंबर',
        oct: 'अक्टूबर',
        nov: 'नवंबर',
        dec: 'दिसंबर'
      }
    },
    select: {
      loading: 'लोड हो रहा है',
      noMatch: 'कोई मिलान नहीं',
      noData: 'कोई डेटा नहीं',
      placeholder: 'चुनें'
    },
    cascader: {
      noMatch: 'कोई मिलान नहीं',
      loading: 'लोड हो रहा है',
      placeholder: 'चुनें',
      noData: 'कोई डेटा नहीं है'
    },
    pagination: {
      goto: 'जाएं',
      pagesize: 'आइटम/पृष्ठ',
      total: 'कुल {total} आइटम',
      pageClassifier: 'पृष्ठ',
      page: 'पृष्ठ',
      prev: 'पिछला पृष्ठ',
      next: 'अगला पृष्ठ',
      currentPage: 'वर्तमान पृष्ठ: {pager}',
      prevPages: 'पिछले {pager} पृष्ठ',
      nextPages: 'अगले {pager} पृष्ठ',
      deprecationWarning:
        'आप कुछ विलुप्त हुए उपयोग के उपयोग कर रहे हैं, कृपया आधिकारिक el-pagination दस्तावेज़ के लिए संदर्भ करें'
    },
    messagebox: {
      title: 'सूचना',
      confirm: 'पुष्टि करें',
      cancel: 'रद्द करें',
      error: 'दर्ज किए गए डेटा में त्रुटि है!'
    },
    upload: {
      deleteTip: 'हटाने के लिए डिलीट बटन दबाएं',
      delete: 'हटाएँ',
      preview: 'छवि देखें',
      continue: 'अपलोड जारी रखें'
    },
    table: {
      emptyText: 'कोई डेटा नहीं',
      confirmFilter: 'छानना',
      resetFilter: 'रीसेट',
      clearFilter: 'सभी',
      sumText: 'कुल'
    },
    tree: { emptyText: 'कोई डेटा नहीं' },
    transfer: {
      noMatch: 'कोई मिलान नहीं',
      noData: 'कोई डेटा नहीं',
      titles: ['सूची 1', 'सूची 2'],
      filterPlaceholder: 'खोज करने के लिए कुछ दर्ज करें',
      noCheckedFormat: 'कुल {total} आइटम',
      hasCheckedFormat: 'चयनित {checked}/{total} आइटम'
    },
    image: { error: 'लोड होने में विफल' },
    pageHeader: { title: 'वापस जाएं' },
    popconfirm: { confirmButtonText: 'पुष्टि करें', cancelButtonText: 'रद्द करें' }
  }
}
